import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_BUSINESS_URL } from '@/utils';
import {
  CommerceWithService,
  NewCommerceWithService,
  CommerceWithServiceFilters,
} from '../models';

const commerceWithServiceService = createApi({
  reducerPath: 'commerceWithServiceService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}`),
  tagTypes: ['CommerceWithService', 'CommerceWithServices'] as const,
  endpoints: (builder) => ({
    getCommerceWithServices: builder.query<
      PaginatedResponse<CommerceWithService>,
      {
        paginated: PaginatedRequest;
        filters?: CommerceWithServiceFilters;
      }
    >({
      query: ({ paginated, filters }) => {
        const params: Record<string, any> = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
          include: 'commercialService',
        };

        if (filters?.commerceId) {
          params.commerceId = filters.commerceId;
        }
        if (filters?.search && filters.search.trim() !== '') {
          params.search = filters.search.trim();
        }

        return {
          url: '/commerce-with-service',
          params,
        };
      },
      providesTags: ['CommerceWithServices'],
    }),
    createCommerceWithService: builder.mutation<
      CommerceWithService,
      NewCommerceWithService
    >({
      query: (body) => ({
        url: '/commerce-with-service',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CommerceWithServices'],
    }),
    deleteCommerceWithService: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/commerce-with-service/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CommerceWithServices'],
    }),
  }),
});

export default commerceWithServiceService;
export const {
  useGetCommerceWithServicesQuery,
  useCreateCommerceWithServiceMutation,
  useDeleteCommerceWithServiceMutation,
} = commerceWithServiceService;
